import React from 'react';
import {AppHelmet, AppWrapper, baseUrl, baseRealtyUrl, baseRealEstateUrl, getUrlWithUtmQueryString } from '@capcenter/shared';
import {
  GlobalIcons,
  ImageCapCenterHQ,
  ImageSmores2,
  ImageSmores,
  ImageGlenAllenVA,
  ImageGlenAllenVA2,
  ImageGlenAllenVAPieDay,
  ImageGlenAllenVAPieDay2,
  ImageGlenAllenVAPieDay3,
  ImageGlenAllenVAPieDay4,
  ImageGlenAllenVAHalloweenTeam,
  ImageGlenAllenVAHalloween,
  ImageRichmondRaceway
} from '@capcenter/shared-legacy';
import {ImageColumbiaOffice} from '@capcenter/shared-service-map';
import './Locations.scss';
import getElasticSearchListings from '../Utilities/GetElasticSearchListings';
import buildListingURL from '../Utilities/BuildURLString';


GlobalIcons();

function State(
  props: any
) {
  const [renderedHtmlListings, setRenderedHtmlListings] = React.useState<Array<any>>([]);
  const [initialized, setInitialized] = React.useState<boolean>(false);
  let htmlListings: any = [];

  async function getListings(state: string) {
    const response = await getElasticSearchListings({isRealty: props.custom.isRealty, state: state});
    return response.json();
  };

  function buildListingLinkText(listingSource: any) {
    const addressLineOne = listingSource?.UnparsedAddress?.replace(/#/g, 'Unit ');
    const city = listingSource?.City;
    const stateOrProvince = listingSource?.StateOrProvince;
    const postalCode = listingSource?.PostalCode;

    let propertyAddress = `${addressLineOne}, ${city}, ${stateOrProvince} ${postalCode}`;

    if (listingSource?.isCapcenterListing) {
      propertyAddress += " (CapCenter Listing)";
    }

    return propertyAddress;
  }

  async function renderListings() {
    const listingResponse = await getListings(props.custom.state);
    const listings = listingResponse.hits.hits;

    for (let i = 0; i < listings.length; i++) {

      let listItem =
        <li key={i}>
          <a href={getUrlWithUtmQueryString(buildListingURL(listings[i]._source))} target='_blank' rel='noreferrer noopener'>
            {buildListingLinkText(listings[i]._source)}
          </a>
        </li>;

      htmlListings.push(listItem);
    }

    setRenderedHtmlListings(htmlListings);
  }

  if (!initialized) {
    setInitialized(true);
    renderListings();
  }

  return (
    <React.Fragment>
      {(
        <AppWrapper>
          <>
            <AppHelmet
              custom={props.custom}
            />

            <div role="document">
              <main className={"locations container pb-4 " + (props.custom.code)} role="main">
                <article>
                  <header>
                    <div className={(props.custom.code)}>
                      <div className={"col-12" + (props.custom.code)}>
                        <h1>{props.custom.title}</h1>
                        <p>{props.custom.description}</p>
                      </div>
                    </div>
                  </header>

                  <section className={(props.custom.code)}>

                    <div className="row">
                      <div className="col-12 col-md-4">
                        <h3>Address</h3>
                        <p>
                          <a href="https://goo.gl/maps/1Yx1KLT4Vmgmwh7j6" title="CapCenter Baltimore branch office in Columbia, Maryland" target="_blank" rel="noreferrer noopener">
                            10320 Little Patuxent Pkwy Suite 200
                            <br />
                            Columbia, MD 21044
                          </a>
                        </p>
                      </div>
                      <div className="col-12 col-md-4">
                        <h3>Contact</h3>
                        <p>
                          <a href="tel:14108584991">
                            +1 (410) 858-4991
                          </a>
                          <br />
                          <a href="mailto:customerservice@capcenter.com">
                            customerservice@capcenter.com
                          </a>
                        </p>
                      </div>
                      <div className="col-12 col-md-4">
                        <h3>Hours</h3>
                        <p>
                          By appointment only
                        </p>
                      </div>
                    </div>
                  </section>

                  <section className={(props.custom.code)}>
                    <div className="row">
                      <div className="col-12">
                        <h2>About CapCenter Mortgage in {props.custom.stateLongName}</h2>
                      </div>

                      <div className="col-12 col-md-8">
                        <p>
                          Maryland is a state in the Eastern, Mid-Atlantic, and Southeastern regions of the United States with a population of 6,177,224 in 2020. Maryland is one of the best places to live in the United States of America because of its distinct seasons with mild temperatures.
                          The capital of Maryland is Annapolis.
                          CapCenter is proud to be located in Maryland where many employees live, work, and enjoy. We host many activities for our employees and our clients on our Maryland campus.
                        </p>

                        <p>
                          Maryland is one of the best places to live and work because of its proximity to shops, restaurants, parks, and businesses. Our Maryland office supports
                          &nbsp;<a href="/contact/best-mortgage-columbia-md">Columbia</a>,&nbsp;
                          Baltimore,
                          Annapolis,
                          Frederick,
                          Silver Spring,
                          Ocean City,
                          Rockville,
                          Bethesda,
                          Hagerstown,
                          Gaithersburg,
                          Salisbury, Bowie,
                          Town Center, Wilde Lake, Owen Brown, Long Reach, Hickory Ridge, Oakland Mills, Harper's Choice, Kings Contrivance, Dorsey's Search, River Hill,
                          Baltimore (Charm City), Inner Harbor,
                          Fells Point, Federal Hill, Canton, Hampden, Mount Vernon, Station North, Charles Village, Federal Hill South, Roland Park, Locust Point,
                          Woodlawn, Lochearn, Milford Mill, Randallstown, Pikesville, Garrison, Owings Mills, Brooklandville, Timonium, Towson,
                          Yorktown, Parkville, Overlea, White Marsh, Glen Arm, Perry Hall, Nottingham, Middle River, Essex, Chase, Bowleys Quarters, Wildwood Beach, Edgemere, Sparrows Point, Dundalk, Brooklyn Park, Linthicum Heights,
                          Ferndale, Glen Burnie, Riviera Beach, Springdale, Jacobsville, Pasadena, Hanover, Elkridge, Jessup, Annapolis Junction, Fort Meade, Ellicott City, Catonsville, Arbutus,
                          Halethorpe, Daniels, Granite, Woodstock, Marriottsville, Eldersburg, Sykesville, Roland,
                          Altholton, West Friendship, Benson, Dayton, Clarksville, Laurel, Williamsburg, Cherry Hill, Bayview, Belair, Edison, Mondawmin,
                          Bel Air, Glen Burnie, Germantown, Hyattsville, Towson, Potomac, Elkton, College Park, Maryland City, Ellicott City,
                          Upper Marlboro, La Plata, Owings Mills, Lanham, Catonsville, Chestertown, North East, Timonium, Odenton, Oxon Hill,
                          Crofton, Chevy Chase, Beltsville, Fort Washington, Dundalk, Randallstown, Frostburg, Capitol Heights, Severna Park, Prince Frederick,
                          Leonardtown, Pikesville, Cockeysville, Temple Hills, Havre de Grace, Sykesville, Reisterstown, White Marsh, Takoma Park,
                          Mechanicsville,
                          and more.
                        </p>

                        <p>
                          &nbsp;See homes in <a href={`${baseRealEstateUrl}/homes/location/city/glen-burnie-md`} target="_blank" rel="noreferrer noopener">Glen Burnie, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/severna-park-md`} target="_blank" rel="noreferrer noopener">Severna Park, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/arnold-md`} target="_blank" rel="noreferrer noopener">Arnold, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/edgewater-md`} target="_blank" rel="noreferrer noopener">Edgewater, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/pasadena-md`} target="_blank" rel="noreferrer noopener">Pasadena, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/laurel-md`} target="_blank" rel="noreferrer noopener">Laurel, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/baltimore-md`} target="_blank" rel="noreferrer noopener">Baltimore, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/bethesda-md`} target="_blank" rel="noreferrer noopener">Bethesda, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/chevy-chase-md`} target="_blank" rel="noreferrer noopener">Chevy Chase, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/potomac-md`} target="_blank" rel="noreferrer noopener">Potomac, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/annapolis-md`} target="_blank" rel="noreferrer noopener">Annapolis, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/ocean-city-md`} target="_blank" rel="noreferrer noopener">Ocean City, MD,</a>&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/frederick-md`} target="_blank" rel="noreferrer noopener">Frederick, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/silver-spring-md`} target="_blank" rel="noreferrer noopener">Silver Spring, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/rockville-md`} target="_blank" rel="noreferrer noopener">Rockville, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/towson-md`} target="_blank" rel="noreferrer noopener">Towson, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/gaithersburg-md`} target="_blank" rel="noreferrer noopener">Gaithersburg, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/clarksburg-md`} target="_blank" rel="noreferrer noopener">Clarksburg, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/ellicott-city-md`} target="_blank" rel="noreferrer noopener">Ellicott City, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/owings-mill-md`} target="_blank" rel="noreferrer noopener">Owings Mill, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/oxon-hill-md`} target="_blank" rel="noreferrer noopener">Oxon Hill, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/hagerstown-md`} target="_blank" rel="noreferrer noopener">Hagerstown, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/hyattsville-md`} target="_blank" rel="noreferrer noopener">Hyattsville, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/eldersburg-md`} target="_blank" rel="noreferrer noopener">Eldersburg, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/timonium-md`} target="_blank" rel="noreferrer noopener">Timonium, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/salisbury-md`} target="_blank" rel="noreferrer noopener">Salisbury, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/bowie-md`} target="_blank" rel="noreferrer noopener">Bowie, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/college-park-md`} target="_blank" rel="noreferrer noopener">College Park, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/bel-air-md`} target="_blank" rel="noreferrer noopener">Bel Air, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/glen-burnie-md`} target="_blank" rel="noreferrer noopener">Glen Burnie, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/elkton-md`} target="_blank" rel="noreferrer noopener">Elkton, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/maryland-city-md`} target="_blank" rel="noreferrer noopener">Maryland City, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/upper-marlboro-md`} target="_blank" rel="noreferrer noopener">Upper Marlboro, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/chestertown-md`} target="_blank" rel="noreferrer noopener">Chestertown, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/crofton-md`} target="_blank" rel="noreferrer noopener">Crofton, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/capitol-heights-md`} target="_blank" rel="noreferrer noopener">Capitol Heights, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/temple-hills-md`} target="_blank" rel="noreferrer noopener">Temple Hills, MD</a>,&nbsp;
                          <a href={`${baseRealEstateUrl}/homes/location/city/randallstown-md`} target="_blank" rel="noreferrer noopener">Randallstown, MD</a>.&nbsp;
                        </p>

                        <p>
                          {"Our mortgage professionals (licensed loan officers and home loan consultants) in " + props.custom.stateLongName + " are mortgage experts trained to guide you through the complicated loan underwriting process so you can close on time with Zero hassles. CapCenter offers conventional, HomeReady®, Home Possible, Jumbo, VA, FHA, and adjustable rate mortgage loan products."}
                        </p>

                        <p>
                          CapCenter specializes in no-fee and low-fee mortgages with low interest rates.
                          We may initially seem like we don't offer the best rates in the market, but many lenders charge additional fees for lower interest rates in the form of points and lender and non-lender closing costs. If you're looking for the lowest rate, try applying expected closing costs to pay down discount points with CapCenter. In an apples to apples comparison, <strong>we offer some of the best rates in the market and do not simply add closing costs into the loan balance</strong>. We are always striving to offer the best overall package for each of our clients' unique needs.
                          We encourage borrowers to not only look at interest rates and APR but also non-lender fees and terms when comparing loan estimates.
                          CapCenter helps borrowers get around closing costs by eliminating fees for borrowers for many popular home loan products.
                          Many of our most popular home loan products have <strong>no closing costs</strong> or <strong>zero closing costs</strong> mortgages, which are often the best mortgage options for <strong>first-time home buyers</strong> and for anyone that may sell or refinance before the loan term (commonly 30 years) because these options allow for more funds to be allocated to the down payment and these options also have less sunk costs associated with paying off the loan on sale of the property or refinancing the loan if interest rates drop.
                          Some of our products, such as the VA home loan for veterans, have <strong>zero down payment</strong> and <strong>zero closing costs</strong> options for certain borrowers and conditions, such as borrowers with service-connected disabilities and appraisal value.
                          Another set of products, such as <a href="https://faq.capcenter.com/article/74-does-capcenter-offer-homeready-and-home-possible-products" target="_blank" rel="noreferrer noopener">HomeReady® and Home Possible</a>, have <strong>low down payment</strong> options for certain borrowers and conditions, such as first-time home buyers and income limits.
                          Our loan consultants can guide you through our loan products to find the best fit loan for your specific situation before and after you apply. We're dedicated to provide you fast and reliable services with our refined operational procedures. It'll feel like we're waiving closing costs, and the most frequently asked question after receiving a free quote is, "what's the catch?" That's our secret sauce, but we assure you that there is no catch and 95% of our past clients would recommend our services to friends and family.
                          In fact, we encourage you to shop around and compare loan estimates (it helps to compare rates, points, terms, mortgage insurance, lender closing costs, and non-lender closing costs as well) and any realty credits. Once we've gain your trust, we're here to help you purchase all your future homes, saving you time and money, over and over again.
                        </p>

                        <p>
                          {props.custom.isRealty ?
                            (<><p><a href={getUrlWithUtmQueryString(`${baseRealtyUrl}/find-best-local-realtor`)} className={'d-flex btn-primary btn-sm'}>Find our best REALTORS® near {props.custom.stateLongName}</a></p><p><a href={getUrlWithUtmQueryString(`${baseRealtyUrl}/forms/request-realty`)} className={'d-flex btn-primary btn-sm'}>Schedule a consultation with a top-rated REALTOR® near {props.custom.stateLongName}</a></p></>) : ""}
                          {props.custom.isMortgage ?
                            (<a href={getUrlWithUtmQueryString(`${baseUrl}/apply-now/`)} className={'d-flex btn-primary btn-sm'}>Apply now for a mortgage in {props.custom.stateLongName}</a>) : ""}
                        </p>

                        <p>
                          <a href={getUrlWithUtmQueryString(`${baseUrl}/mortgage-rates/maryland`)} className={'d-flex btn-primary btn-sm'}>View our best mortgage interest rates today in {props.custom.stateLongName}</a>
                        </p>

                        <p>
                          <a href={getUrlWithUtmQueryString(`${baseUrl}/mortgage-calculator/purchase`)} className={'d-flex btn-primary btn-sm'}>Get a free, anonymous quote calculated to compare mortgage rates and closing costs in {props.custom.stateLongName}</a>
                        </p>

                        <p>&nbsp;</p>
                      </div>

                      <div className="col-12 col-md-4 mb-4">
                        <img src={ImageColumbiaOffice} alt={'CapCenter Columbia, Maryland branch office 10320 Little Patuxent Pkwy Suite 200, Columbia, MD 21044'} />
                      </div>

                      <div className="col-12 image-gallery">
                        <img src={ImageGlenAllenVA} alt={props.custom.title + " best mortgage home loan in Maryland lender company low fee zero closing cost"} />
                        <img src={ImageRichmondRaceway} alt={props.custom.title + " RVA Richmond Raceway best mortgage home loan in Maryland lender company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVA2} alt={props.custom.title + " best mortgage home loan in Maryland lender company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVAPieDay} alt={props.custom.title + " RVA Richmond Glen Allen VA Pie Day 1 best mortgage home loan lender in Maryland company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVAPieDay2} alt={props.custom.title + " RVA Richmond Glen Allen VA Pie Day 2 best mortgage home lender in Maryland company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVAPieDay3} alt={props.custom.title + " RVA Richmond Glen Allen VA Pie Day 3 best mortgage home lender in Maryland company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVAPieDay4} alt={props.custom.title + " RVA Richmond Glen Allen VA Pie Day 4 best mortgage home lender in Maryland company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVAHalloweenTeam} alt={props.custom.title + " RVA Richmond Glen Allen VA in Maryland Halloween Winning Team best mortgage home loan lender company in Maryland"} />
                        <img src={ImageGlenAllenVAHalloween} alt={props.custom.title + " Halloween best mortgage home loan lender company in Maryland"} />
                        <img src={ImageSmores} alt={props.custom.title + " S'mores Day best mortgage home loan lender company in Maryland low fee zero closing cost"} />
                        <img src={ImageSmores2} alt={props.custom.title + " S'mores Day best mortgage home loan lender company in Maryland low fee zero closing cost"} />
                      </div>
                    </div>
                  </section>

                  <section className={(props.custom.code)}>
                    <div className="row">
                      <div className="col-12">
                        <img src={ImageCapCenterHQ} alt={props.custom.title + " best mortgage home loan in Maryland lender high quality low fee zero closing costs"} width={'500px'}/>
                      </div>
                    </div>
                  </section>

                  <section className={(props.custom.code)}>
                    <div className="row">
                      <div className="col-12">
                        <h4>
                          <a href={`${baseRealEstateUrl}/homes/location/state/maryland`} target="_blank" rel="noreferrer noopener">
                          Homes for Sale in {props.custom.stateLongName}
                          </a>
                        </h4>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <ol>
                          {renderedHtmlListings}
                        </ol>
                      </div>
                    </div>
                  </section>

                </article>
              </main>
            </div>
          </>
        </AppWrapper>
      )}
    </React.Fragment>
  );
}

export default State;
